import { Form } from 'react-bootstrap'
import styled from 'styled-components'

export const PasswordInputStyled = styled(Form.Control)`
  border-radius: 0.25rem !important;
`

export const FormInputStyled = styled(Form.Group)`
  width: 50%;
  padding-left: 2rem;
  /* padding-right: 0.5rem !important; */

  .label {
    padding-top: 1rem;
    padding-right: 0.5rem;
  }

  .input-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }
`

export const PasswordEye = styled.i`
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  position: absolute;
  align-self: center;
  right: 0;
  z-index: 5;
`
